import { render, staticRenderFns } from "./ProductRecord.vue?vue&type=template&id=6895775d&scoped=true&"
import script from "./ProductRecord.vue?vue&type=script&lang=js&"
export * from "./ProductRecord.vue?vue&type=script&lang=js&"
import style0 from "./ProductRecord.vue?vue&type=style&index=0&id=6895775d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6895775d",
  null
  
)

export default component.exports